import React from "react";

interface FieldPrintProps {
  s: {[key: string]: string[]};
  row: string;
}

export function fieldCount(s: {[key: string]: string[]}, row: string) {
  return s[row]
    .filter((f) => f !== '-')
    .filter((f) => f !== 'niemand')
    .filter((value, index, self) => {
      return self.indexOf(value) === index;
    })
    .length;
}

function FieldPrint(props: FieldPrintProps) {
  const { s, row } = props;
  const sFiltered = s[row]
    .filter((f) => f !== '-')
    .filter((f) => f !== 'niemand')
    .filter((value, index, self) => {
      return self.indexOf(value) === index;
    });
  const spans = sFiltered
    .map((f, index) => {
      // last
      if (index === sFiltered.length - 1) {
        return (<span  key={f}>{f}</span>);
      }
      if (index === sFiltered.length - 2) {
        return (<span key={f}>{f} und </span>);
      }
      return (<span className="printField" key={f}>{f}, </span>);
    });
  return (<span>{spans}</span>);
}

export default FieldPrint
;
